// Firebase configuration for Customer App
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

// Your Firebase configuration object
// Replace with your actual Firebase config from Firebase Console
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDmRrmUZLpSes7Y4Geq88b-HTKT8jP65Hs",
  authDomain: "nistylez-b2a1c.firebaseapp.com",
  projectId: "nistylez-b2a1c",
  storageBucket: "nistylez-b2a1c.firebasestorage.app",
  messagingSenderId: "259583770450",
  appId: "1:259583770450:web:ec529de100b92eb06bc48b",
  measurementId: "G-60XDSP0D1C"
};

// Initialize Firebase - check if app already exists to avoid duplicate initialization
let app;
try {
  app = getApp();
} catch (error) {
  // No app exists, initialize it
  app = initializeApp(firebaseConfig);
}

// Initialize Firebase Cloud Messaging and get a reference to the service
// Note: This may not be supported in all browsers (e.g., Safari private mode)
let messaging = null;
try {
  // Check if messaging is supported before initializing
  const messagingSupportPromise = isSupported();
  messagingSupportPromise.then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
      console.log('✅ Firebase Messaging is supported and initialized');
    } else {
      console.warn('⚠️ Firebase Messaging is not supported in this browser');
    }
  }).catch((error) => {
    console.warn('⚠️ Firebase Messaging check failed:', error.message);
  });
} catch (error) {
  console.warn('⚠️ Firebase Messaging initialization failed:', error.message);
}

// VAPID key for web push notifications
// Get this from Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
const vapidKey = "BEVRPx-OOqUPusEVKeqFbfvtjybQ05yi2ZGhnrHA5ARMhjvCPIv8hMYlWOXavGZZYi8TRzSkMvL3d7ZKLWcsgpw";

// Function to get FCM token
export const getFCMToken = async () => {
  try {
    if (!messaging) {
      console.warn('⚠️ Firebase Messaging is not available. Notifications are disabled.');
      return null;
    }
    const token = await getToken(messaging, { vapidKey });
    console.log('FCM Token:', token);
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

// Function to handle foreground messages
export const onMessageListener = () => {
  return new Promise((resolve, reject) => {
    if (!messaging) {
      console.warn('⚠️ Firebase Messaging is not available. Cannot listen for messages.');
      reject(new Error('Firebase Messaging not available'));
      return;
    }
    onMessage(messaging, (payload) => {
      console.log('Message received in foreground:', payload);
      resolve(payload);
    });
  });
};

// Function to request notification permission
export const requestNotificationPermission = async () => {
  try {
    // Check if Notifications API is available
    if (!('Notification' in window)) {
      console.warn('⚠️ This browser does not support notifications');
      return false;
    }
    
    if (!messaging) {
      console.warn('⚠️ Firebase Messaging is not available. Notifications are disabled.');
      return false;
    }
    
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('Notification permission granted');
      return true;
    } else {
      console.log('Notification permission denied');
      return false;
    }
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

// Function to check if Firebase Messaging is available
export const isMessagingAvailable = () => {
  return messaging !== null;
};

// Function to check if browser supports Firebase Messaging
export const checkMessagingSupport = async () => {
  try {
    return await isSupported();
  } catch (error) {
    console.warn('Error checking messaging support:', error);
    return false;
  }
};

export { messaging, app };
export default app;
